import React, { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import NotificationCenter from "../components/NotificationCenter/NotificationCenter";
import Workspace from "../components/Workspace/Workspace";
import { getRoutesList } from "../../DesktopRoutes";
import useMountEffect from "../../mountEffect";
import { Redirect, Route, Switch } from "react-router-dom";
import FormatTextdirectionLToRIcon from "@material-ui/icons/FormatTextdirectionLToR";
import FormatTextdirectionRToLIcon from "@material-ui/icons/FormatTextdirectionRToL";
import Hidden from "@material-ui/core/Hidden";
import { MobileBreakpoint } from "../../styleVariables";
import SettingsIcon from "@material-ui/icons/Settings";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { logoutUser, getUserDetails } from "../../store/actions/authActionCreators";
import * as logger from '../../logger';
import FreeTrialAlertsDialog from '../components/Dialog/FreeTrialAlertsDialog';
import PaymentFailedDialog from '../components/Dialog/PaymentFailedAlertsDialog';
import {
  getSubscriptionPlans, paySubscriptionAction, getSubscriptionStatus,
  updateFreeTrialModal,
  getPaymentLink,
  updatePaymentFailedModal
} from "../../store/actions/paymentsActionCreator";
import { getTripLedgerData, getTripLedgerDataV2 } from '../../store/actions/homeActionCreator';
import AccountDetailsDialog from '../components/AccountDetails/AccountDetails';
import { freeTrailShown } from '../../store/actions/paymentsActionCreator';
import { onlinePaymentsConfig, getFilteredConfig } from '../../store/actions/userActionCreators';
import { toggleEditInvoiceFlag } from '../../store/actions/tripActionCreator';
import { defaultPageNo, defaultPageSize } from "../../paginationVariables";
import moment from 'moment';
import { getTripStartDateFilterValues } from "../../utils/utils";
import { TRIP_FILTER_STATUS_MAPPING } from "../../store/constants";

const useStyles = makeStyles(theme => ({
  panel: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
    minHeight: "calc(100vh - 70px)",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      minHeight: "calc(100vh - 64px)",
      paddingTop: "70px"
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      minHeight: "calc(100vh - 56px)",
      paddingTop: "56px"
    },
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 70px)"
    },
    display: "flex",
    flexDirection: "row",
    flexGrow: 1
  },
  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1) * 2,
    right: theme.spacing(1) * 3
  }
}));

const DesktopHome = ({ history, location, user, trip, payments, dispatchUpdateModal, dispatchFreeTrailShown, dispatchGetTripLedgerAction, dispatchUpdatePaymentFailedModal,
  dispatchGetSubscriptionPaymentLinkAction, dispatchGetOnlinePaymentsConfig, dispatchEditInvoiceFlag,
  dispatchFetchUserDetails, dispatchGetSubscriptionStatusAction, dispatchGetFilteredConfig, dispatchFetchUserDetailsKapture }) => {
  const classes = useStyles();
  const [state, dispatch] = useState({});
  const [opened, setOpened] = useState(true);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [openFreeTrial, setOpenFreeTrial] = useState(false);
  const [openPaymentFailed, setOpenPaymentFailed] = useState(false);
  const mediaMatcher = matchMedia(`(max-width: ${MobileBreakpoint}px)`);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [freeTrailCalled, setFreeTrailCalled] = useState(false);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [addTripOverlayIsOpen, setAddTripOverlayIsOpen] = useState(false);
  const [firstTripCreated, setFirstTripCreated] = useState(false);
  const [paymentsFreeTrailModal, setPaymentsFreeTrailModal] = useState(false);
  const [showFreeTrail, setShowFreeTrail] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [onlinePaymentConfig, setOnlinePaymentConfig] = useState({});
  const [fuelCardConfig, setFuelCardConfig] = useState({});

  let dateFilterValues = getTripStartDateFilterValues();
  const getDateRangeValue = () => {
    let date = `${moment(dateFilterValues['ALL_MONTHS']["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues['ALL_MONTHS']["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    return [date]
  }

  const routes = getRoutesList(user && user.userInfo && user.userInfo.role ? user.userInfo.role : "", onlinePaymentConfig, fuelCardConfig);

  useEffect(() => {

    const requestData = {
      filteredKeys: ["fuel_card", "online_payments_config", 
      "dwebSearchBebounceMs", "panRegex", "gstRegex", "pincodeRegex", 
      "GST_STATE_LIST", "subscription", "coming_soon", "VehicleRegex", "event_tracking"]
    }

    dispatchGetFilteredConfig(
      requestData,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          logger.log("Desktop Home", `Get filtered configs ${requestData}`)
          dispatchFetchUserDetails(
            (data) => {
              if (data && data.status && data.status.code && data.status.code == 200) {
                logger.log("Header Dweb", "Fetch user details successfull");
              }
            },
            () => {
              logger.log("Header Dweb", "Fetch user details failed");
            }
          )
        }
      },
      () => {
        logger.log("Desktop Home", `Get filtered config failed - ${requestData} `);
      }
    )

    if (trip && trip.editInvoiceFlag) {
      dispatchEditInvoiceFlag(false);
    }

  }, [location]);

  let premEnabled = user && user.configs && user.configs.subscription && user.configs.subscription.enabled && user.configs.subscription.enabled == 1 ? true : false;
  if (premEnabled) {
    if (payments && payments.paymentFailed && payments.paymentFailed === true) {
      setTimeout(() => {
        if (!payments.paymentFailedModal) {
          dispatchUpdatePaymentFailedModal(true);
          setOpenPaymentFailed(true);
        }
      }, 2000)
    }
  }

  useEffect(() => {

    if (premEnabled && showFreeTrail) {
      if (payments && payments.freeTrial && payments.freeTrial === true && !payments.shownFreeTrail) {
        setTimeout(() => {
          if (location && (!location.state || !location.state.pageTitle || (location.state.pageTitle && location.state.pageTitle != "Premium"))) {
            // dispatchUpdateModal(true);
            setOpenFreeTrial(true);
          }
        }, 5000)
      }
    }


  }, [showFreeTrail, payments.freeTrial]);

  useEffect(() => {
    if (user.isNewUser) {
      setProfileDialogOpen(true);
    } else {
      setProfileDialogOpen(false);
    }
  }, [user.isNewUser]);

  useEffect(() => {
    if (user.showAddTripOverlay) {
      setAddTripOverlayIsOpen(true);
    } else {
      setAddTripOverlayIsOpen(false);
    }
  }, [user.showAddTripOverlay]);

  useEffect(() => {

    if (user && user.userInfo && user.userInfo.role) {
      setUserRole(user.userInfo.role);
    }

    if (user && user.onlinePaymentConfig) {
      setOnlinePaymentConfig(user.onlinePaymentConfig);
    }

    if (user && user.fuelCardConfig) {
      setFuelCardConfig(user.fuelCardConfig)
    }

  }, [user.userInfo, user.onlinePaymentConfig, user.fuelCardConfig]);

  useEffect(() => {

    setTimeout(() => {
      const kapSnippet = document.getElementById("kap-snippet");
      const tripOverlay = localStorage.getItem("CheckTripOverlay");

      if (user && user.userInfo && !kapSnippet && !user.isNewUser && tripOverlay) {

        // dispatchFetchUserDetailsKapture(
        //   (data) => {
        //     if (data && data.status && data.status.code && data.status.code == 200) {
        //       logger.log("Header Dweb", "Fetch user details successful");
        //       appendSdkScript();
        //     }
        //   },
        //   () => {
        //     logger.log("Header Dweb", "Fetch user details failed");
        //   }
        // )

      }
    }, 5000);

  }, [user.showAddTripOverlay]);

  const appendSdkScript = () => {

    // var userInfoLocalStorage = localStorage.getItem('USER_INFO_PROFILE') ? JSON.parse(localStorage.getItem('USER_INFO_PROFILE')).user : {};


    // if (userInfoLocalStorage && userInfoLocalStorage.crmCreds && userInfoLocalStorage.crmCreds.kaptureCreds &&
    //   userInfoLocalStorage.crmCreds.kaptureCreds.userCode && userInfoLocalStorage.crmCreds.kaptureCreds.userIv) {
    //   const script = document.createElement('script')

    //   var kapchatScript = document.createElement("script");
    //   kapchatScript.setAttribute("type", "text/javascript");
    //   kapchatScript.setAttribute("id", "kap-snippet");
    //   kapchatScript.setAttribute("data-supportkey", '6bd18e33268b40addb6b2d88825d4849a332301f4164538578');
    //   kapchatScript.setAttribute("data-script-load-type", "onload");
    //   kapchatScript.setAttribute("data-chat-type", "RNF");
    //   kapchatScript.setAttribute("data-chat-for", "TICKET");
    //   kapchatScript.setAttribute("data-iv", userInfoLocalStorage && userInfoLocalStorage.crmCreds && userInfoLocalStorage.crmCreds.kaptureCreds && userInfoLocalStorage.crmCreds.kaptureCreds.userIv ? userInfoLocalStorage.crmCreds.kaptureCreds.userIv : "cus_iv");
    //   kapchatScript.setAttribute("data-customercode", userInfoLocalStorage && userInfoLocalStorage.crmCreds && userInfoLocalStorage.crmCreds.kaptureCreds && userInfoLocalStorage.crmCreds.kaptureCreds.userCode ? userInfoLocalStorage.crmCreds.kaptureCreds.userCode : "cus_code");
    //   kapchatScript.setAttribute("src", "https://selfserveapp.kapturecrm.com/js/init_chat.js");
    //   document.head.append(kapchatScript);

    // }


  };



  const resizeDispatch = () => {
    if (typeof Event === "function") {
      window.dispatchEvent(new Event("resize"));
    } else {
      const evt = window.document.createEvent("UIEvents");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
    }
  };

  const handleDrawerToggle = () => {
    setOpened(!opened);
    resizeDispatch();
  };

  const handleNotificationToggle = () =>
    setNotificationsOpen(!notificationsOpen);

  const handleFullscreenToggle = () => {
    const element = document.querySelector("#root");
    const isFullscreen =
      document.webkitIsFullScreen || document.mozFullScreen || false;

    element.requestFullScreen =
      element.requestFullScreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      function () {
        return false;
      };
    document.cancelFullScreen =
      document.cancelFullScreen ||
      document.webkitCancelFullScreen ||
      document.mozCancelFullScreen ||
      function () {
        return false;
      };
    isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
  };

  const goToPremium = (data) => {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
  }
  const goToTryAgainPayment = (data) => {
    if (payments && payments.paymentFailed && payments.paymentFailed === true && payments.subscriptionStatus && payments.subscriptionStatus.orderId) {
      dispatchGetSubscriptionPaymentLinkAction(
        payments.subscriptionStatus.orderId,
        (data) => {
          if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
            window.location.href = data.response.paymentLink;
          }
        },
        () => { },
      )
    }
  }
  const handleFreeTrialClose = (status) => {
    setFreeTrailCalled(true)
    setOpenFreeTrial(false);
    setShowFreeTrail(true);
    dispatchUpdateModal(false);
  };
  const handleFreeTrialConfirm = (status) => {
    setFreeTrailCalled(true)
    setOpenFreeTrial(false);
    setShowFreeTrail(true);
    dispatchUpdateModal(true);
    goToPremium();
  };
  const handlePaymentFailedClose = (status) => {
    setOpenPaymentFailed(false);
    dispatchUpdatePaymentFailedModal(true);
  };
  const handlePaymentFailedConfirm = (status) => {
    setOpenPaymentFailed(false);
    dispatchUpdatePaymentFailedModal(true);
    goToTryAgainPayment();
  };

  const getRoutes = (
    <Switch>
      {routes.items.map((item, index) =>
        (item.type === "external") ? (
          <Route
            exact
            path={item.path}
            component={item.component}
            name={item.name}
            key={index}
          />
        ) : item.type === "submenu" ? (

          item.children.map((subItem, index) =>
            (subItem && subItem.tabs && subItem.tabs.length > 0) ?
              (
                subItem.tabs.map((tabItem) => (
                  < Route
                    exact
                    path={`${item.path}${subItem.path}${tabItem.path}`}
                    component={subItem.component}
                    name={subItem.name}
                  />
                ))
              )
              :
              (
                < Route
                  exact
                  path={`${item.path}${subItem.path}`}
                  component={subItem.component}
                  name={subItem.name}
                />
              )
          )



        ) : (
          <Route
            exact
            path={item.path}
            component={item.component}
            name={item.name}
            key={index}
          />
        )
      )}
      {
        routes.items.map((item, index) =>
          (item.type === "submenu") ? (
            <Route
              exact
              path={item.path}
              component={item.component}
              name={item.name}
              key={index}
            />
          ) : null
        )
      }
      <Redirect to="/404" />
    </Switch >
  );


  useMountEffect(() => {
    if (mediaMatcher.matches) setOpened(false);
    mediaMatcher.addListener(match => {
      setTimeout(() => {
        if (match.matches) setOpened(false);
        else setOpened(true);
      }, 300);
    });

    const unlisten = history.listen(() => {
      if (mediaMatcher.matches) setOpened(false);
      if (document.querySelector("#root > div > div > main")) {
        document.querySelector("#root > div > div > main").scrollTop = 0;
      }
    });

    return () => {
      unlisten();
      mediaMatcher.removeListener(match => {
        setTimeout(() => {
          if (match.matches) setOpened(false);
          else setOpened(true);
        }, 300);
      });
    };
  });
  let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

  const handleAddProfileModalClose = () => {
    setProfileDialogOpen(false);
  }

  return (
    <>
      <Header
        logoAltText="TransportBook"
        userDetails={user}
        logo={`${process.env.PUBLIC_URL}/assets/images/logo-small.svg`}
        toggleDrawer={handleDrawerToggle}
        toggleNotifications={handleNotificationToggle}
        toggleFullscreen={handleFullscreenToggle}
      />
      <div className={classNames(classes.panel, "theme-dark")}>
        <Sidebar
          routes={routes.items}
          opened={opened}
          toggleDrawer={handleDrawerToggle}
          subscriptionStatus={payments && payments.subscriptionStatus ? payments.subscriptionStatus : {}}
          userData={user}
        />
        <Workspace opened={opened} subscriptionStatus={subscriptionStatus}>{getRoutes}</Workspace>
        <NotificationCenter
          notificationsOpen={notificationsOpen}
          toggleNotifications={handleNotificationToggle}
        />
        {openFreeTrial && !addTripOverlayIsOpen && !profileDialogOpen && userRole != "USER" && <FreeTrialAlertsDialog confirmOpen={openFreeTrial} status={payments.subscriptionStatus} onClose={handleFreeTrialClose} onConfirm={handleFreeTrialConfirm} />}
        {openPaymentFailed && <PaymentFailedDialog confirmOpen={openPaymentFailed} status={payments.subscriptionStatus} onClose={handlePaymentFailedClose} onConfirm={handlePaymentFailedConfirm} />}
        {profileDialogOpen && userRole != "USER" && <AccountDetailsDialog open={profileDialogOpen} onClose={handleAddProfileModalClose} />}
      </div>
    </>
  );
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchFetchUserDetails: (onSuccess, onFailure) => {
    dispatch(getUserDetails(onSuccess, onFailure))
  },
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure))
  },
  dispatchUpdateModal: (value) => {
    dispatch(updateFreeTrialModal(value))
  },
  dispatchUpdatePaymentFailedModal: (value) => {
    dispatch(updatePaymentFailedModal(value))
  },
  dispatchGetSubscriptionPaymentLinkAction: (id, onSuccess, onFailure) => {
    dispatch(getPaymentLink(id, onSuccess, onFailure))
  },
  dispatchGetTripLedgerAction: (requestData, onSuccess, onFailure) =>
    dispatch(
      getTripLedgerDataV2(
        requestData, onSuccess, onFailure
      )
    ),
  dispatchFreeTrailShown: (value) => {
    dispatch(freeTrailShown(value))
  },
  dispatchGetOnlinePaymentsConfig: (onSuccess, onFailure) => { dispatch(onlinePaymentsConfig(onSuccess, onFailure)) },
  dispatchEditInvoiceFlag: (editInvoiceFlag) => {
    dispatch(toggleEditInvoiceFlag(editInvoiceFlag))
  },
  dispatchGetFilteredConfig: (data, onSuccess, onFailure) => {
    dispatch(getFilteredConfig(data, onSuccess, onFailure))
  },
  dispatchFetchUserDetailsKapture: (onSuccess, onFailure, kaptureIntegration = true) => {
    dispatch(getUserDetails(onSuccess, onFailure, kaptureIntegration = true))
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DesktopHome);
